<section class="termo-detalhe" aria-labelledby="termo-detalhe-title">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <header class="termo-detalhe__header">
      <h2 id="termo-detalhe-title" class="termo-detalhe__title">
        @if (modoCriacao()) {
          Novo Termo
        } @else if (alterando()) {
          Alterar Termo
        } @else {
          Detalhes do Termo
        }
      </h2>

      <div class="termo-detalhe__header-actions">
        @if (modoCriacao()) {
          <button
            type="button"
            class="btn-outline-primary btn-toolbar"
            data-testid="termo-detalhe-cancelar"
            (click)="onCancelarCriacao()"
          >
            Cancelar
          </button>
          <button
            type="submit"
            class="btn-primary btn-toolbar"
            data-testid="termo-detalhe-criar"
            [disabled]="!podeEnviar()"
          >
            Criar Termo
          </button>
        } @else if (alterando()) {
          <button
            type="button"
            class="btn-outline-primary btn-toolbar"
            data-testid="termo-detalhe-cancelar-alteracao"
            (click)="onCancelarAlteracao()"
          >
            Cancelar
          </button>
          <button
            type="submit"
            class="btn-primary btn-toolbar"
            data-testid="termo-detalhe-salvar"
            [disabled]="!podeEnviar()"
          >
            Salvar Alterações
          </button>
        } @else {
          <app-status-badge [status]="termo().status" data-testid="termo-detalhe-status" />
          <button
            type="button"
            class="btn-primary btn-toolbar"
            data-testid="termo-detalhe-alterar"
            (click)="onAlterar()"
          >
            Alterar Termo
          </button>
        }
      </div>
    </header>

    @if (modoCriacao()) {
      <p class="termo-detalhe__aviso" role="note" data-testid="termo-detalhe-aviso-criacao">
        Preencha todos os campos e anexe o PDF para criar o termo. Ele só entra na lista
        depois disso.
      </p>
    }

    @if (exibindoFormulario()) {
      <div class="termo-detalhe__field">
        <label class="termo-detalhe__label" for="termo-detalhe-nome">
          Nome do Termo
          <span class="termo-detalhe__required" aria-hidden="true">*</span>
        </label>
        <input
          id="termo-detalhe-nome"
          type="text"
          class="termo-detalhe__control"
          formControlName="nome"
          autocomplete="off"
          aria-required="true"
          data-testid="termo-detalhe-nome"
          [class.termo-detalhe__control--invalid]="showControlError('nome')"
          [attr.aria-invalid]="showControlError('nome')"
          [attr.aria-describedby]="showControlError('nome') ? 'termo-detalhe-nome-error' : null"
        />
        @if (showControlError('nome')) {
          <span
            id="termo-detalhe-nome-error"
            class="termo-detalhe__error"
            role="alert"
            data-testid="termo-detalhe-nome-error"
          >
            Informe o nome do termo.
          </span>
        }
      </div>

      <div class="termo-detalhe__field">
        <label class="termo-detalhe__label" for="termo-detalhe-descricao">
          Descrição
          <span class="termo-detalhe__required" aria-hidden="true">*</span>
        </label>
        <textarea
          id="termo-detalhe-descricao"
          class="termo-detalhe__control termo-detalhe__textarea"
          formControlName="descricao"
          rows="3"
          aria-required="true"
          data-testid="termo-detalhe-descricao"
          [class.termo-detalhe__control--invalid]="showControlError('descricao')"
          [attr.aria-invalid]="showControlError('descricao')"
          [attr.aria-describedby]="
            showControlError('descricao') ? 'termo-detalhe-descricao-error' : null
          "
        ></textarea>
        @if (showControlError('descricao')) {
          <span
            id="termo-detalhe-descricao-error"
            class="termo-detalhe__error"
            role="alert"
            data-testid="termo-detalhe-descricao-error"
          >
            Informe a descrição do termo.
          </span>
        }
      </div>

      @if (alterando()) {
        <div class="termo-detalhe__field">
          <label class="termo-detalhe__label" for="termo-detalhe-status-campo">
            Status
            <span class="termo-detalhe__required" aria-hidden="true">*</span>
          </label>
          <select
            id="termo-detalhe-status-campo"
            class="termo-detalhe__control"
            formControlName="status"
            data-testid="termo-detalhe-status-campo"
          >
            @for (opcao of statusOptions; track opcao) {
              <option [value]="opcao">{{ opcao }}</option>
            }
          </select>
        </div>
      }

      <div class="termo-detalhe__field">
        <label class="termo-detalhe__label" for="termo-detalhe-motivo">
          {{ modoCriacao() ? 'Motivo da criação' : 'Motivo da alteração' }}
          <span class="termo-detalhe__required" aria-hidden="true">*</span>
        </label>
        <textarea
          id="termo-detalhe-motivo"
          class="termo-detalhe__control termo-detalhe__textarea"
          formControlName="motivoAlteracao"
          rows="2"
          maxlength="500"
          aria-required="true"
          data-testid="termo-detalhe-motivo"
          [class.termo-detalhe__control--invalid]="showControlError('motivoAlteracao')"
          [attr.aria-invalid]="showControlError('motivoAlteracao')"
          [attr.aria-describedby]="
            showControlError('motivoAlteracao')
              ? 'termo-detalhe-motivo-dica termo-detalhe-motivo-error'
              : 'termo-detalhe-motivo-dica'
          "
        ></textarea>
        <span id="termo-detalhe-motivo-dica" class="termo-detalhe__dica">
          Aparece na coluna Alterações do histórico, na linha da versão salva.
        </span>
        @if (showControlError('motivoAlteracao')) {
          <span
            id="termo-detalhe-motivo-error"
            class="termo-detalhe__error"
            role="alert"
            data-testid="termo-detalhe-motivo-error"
          >
            {{ modoCriacao() ? 'Informe o motivo da criação.' : 'Informe o motivo da alteração.' }}
          </span>
        }
      </div>
    } @else {
      <dl class="termo-detalhe__dados" data-testid="termo-detalhe-visualizacao">
        <div class="termo-detalhe__dado">
          <dt class="termo-detalhe__label">Nome do Termo</dt>
          <dd class="termo-detalhe__valor" data-testid="termo-detalhe-valor-nome">
            {{ termo().nome }}
          </dd>
        </div>

        <div class="termo-detalhe__dado">
          <dt class="termo-detalhe__label">Descrição</dt>
          <!-- Sem quebra de linha aqui: o pre-line a exibiria. -->
          <dd class="termo-detalhe__valor termo-detalhe__valor--texto">{{ termo().descricao }}</dd>
        </div>

        <div class="termo-detalhe__grid">
          <div class="termo-detalhe__dado">
            <dt class="termo-detalhe__label">Versão</dt>
            <dd class="termo-detalhe__valor" data-testid="termo-detalhe-valor-versao">
              {{ termo().versao }}
            </dd>
          </div>
          <div class="termo-detalhe__dado">
            <dt class="termo-detalhe__label">Data da versão</dt>
            <dd class="termo-detalhe__valor">{{ formatDate(termo().dataVersao) }}</dd>
          </div>
          <div class="termo-detalhe__dado">
            <dt class="termo-detalhe__label">Status</dt>
            <dd class="termo-detalhe__valor">{{ termo().status }}</dd>
          </div>
        </div>

        <div class="termo-detalhe__dado">
          <dt class="termo-detalhe__label">Motivo da alteração</dt>
          @if (motivoVersaoAtual()) {
            <dd
              class="termo-detalhe__valor termo-detalhe__valor--texto"
              data-testid="termo-detalhe-valor-motivo"
            >{{ motivoVersaoAtual() }}</dd>
          } @else {
            <dd
              class="termo-detalhe__valor termo-detalhe__valor--vazio"
              data-testid="termo-detalhe-valor-motivo"
            >
              Nenhum motivo registrado para a versão {{ termo().versao }}.
            </dd>
          }
        </div>
      </dl>
    }

    <div class="termo-detalhe__field">
      <span class="termo-detalhe__label">
        Arquivo (PDF)
        @if (exibindoFormulario()) {
          <span class="termo-detalhe__required" aria-hidden="true">*</span>
        }
      </span>

      <div
        class="termo-detalhe__arquivo-box"
        [class.termo-detalhe__arquivo-box--invalid]="arquivoInvalido()"
      >
        <!-- Oculto: aberto pelos botões Anexar/Substituir PDF. -->
        <input
          #seletorArquivo
          type="file"
          class="termo-detalhe__sr-only"
          accept="application/pdf,.pdf"
          aria-hidden="true"
          tabindex="-1"
          data-testid="termo-detalhe-arquivo-input"
          (change)="onArquivoSelecionado($event)"
        />

        @if (arquivoAtual(); as arquivo) {
          <div class="termo-detalhe__arquivo">
            <span class="termo-detalhe__arquivo-icone" aria-hidden="true">PDF</span>
            <span class="termo-detalhe__arquivo-dados">
              <span class="termo-detalhe__arquivo-nome" data-testid="termo-detalhe-arquivo-nome">
                {{ arquivo.nome }}
              </span>
              <span class="termo-detalhe__arquivo-meta" data-testid="termo-detalhe-arquivo-meta">
                {{ arquivo.resumo }}
              </span>
            </span>
            <span class="termo-detalhe__arquivo-acoes">
              @if (arquivo.url || arquivo.idVersao) {
                <button
                  type="button"
                  class="termo-detalhe__arquivo-visualizar"
                  aria-label="Visualizar o PDF"
                  title="Visualizar o PDF"
                  data-testid="termo-detalhe-visualizar-pdf"
                  (click)="onVisualizarArquivo()"
                >
                  <svg
                    class="termo-detalhe__arquivo-acao-icone"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                </button>
              }

              @if (exibindoFormulario()) {
                <button
                  type="button"
                  class="btn-outline-primary btn-toolbar"
                  data-testid="termo-detalhe-substituir-pdf"
                  (click)="seletorArquivo.click()"
                >
                  Substituir PDF
                </button>
                @if (arquivoNovo()) {
                  <button
                    type="button"
                    class="termo-detalhe__arquivo-excluir"
                    aria-label="Descartar o PDF escolhido"
                    data-testid="termo-detalhe-excluir-pdf"
                    (click)="onRemoverArquivo()"
                  >
                    <svg
                      class="termo-detalhe__arquivo-excluir-icone"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      aria-hidden="true"
                    >
                      <path d="M4 7h16" />
                      <path d="M10 4h4a1 1 0 0 1 1 1v2H9V5a1 1 0 0 1 1-1z" />
                      <path d="M6 7l1 12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-12" />
                      <path d="M10 11v6M14 11v6" />
                    </svg>
                  </button>
                }
              }
            </span>
          </div>
        } @else {
          <div class="termo-detalhe__arquivo">
            <p class="termo-detalhe__arquivo-vazio" data-testid="termo-detalhe-arquivo-vazio">
              Nenhum arquivo publicado para este termo.
            </p>
            @if (exibindoFormulario()) {
              <button
                type="button"
                class="btn-outline-primary btn-toolbar"
                data-testid="termo-detalhe-anexar-pdf"
                (click)="seletorArquivo.click()"
              >
                Anexar PDF
              </button>
            }
          </div>
        }

        @if (arquivoInvalido()) {
          <span
            class="termo-detalhe__error"
            role="alert"
            data-testid="termo-detalhe-arquivo-error"
          >
            Anexe o arquivo PDF do termo.
          </span>
        }

        @if (exibindoFormulario()) {
          <p class="termo-detalhe__aviso" role="note">
            O arquivo deve estar no formato PDF e o tamanho máximo permitido é de 10MB.
          </p>
        }
      </div>
    </div>

    @if (!modoCriacao()) {
      <div class="termo-detalhe__field">
        <h3 class="termo-detalhe__subtitle" id="termo-detalhe-historico-title">
          Histórico de Versões
        </h3>

        @if (termo().historico.length === 0) {
          <p class="termo-detalhe__arquivo-vazio" data-testid="termo-detalhe-historico-vazio">
            Nenhuma versão publicada.
          </p>
        } @else {
          <app-data-table ariaLabel="Histórico de versões do termo">
            <thead>
              <tr>
                <th scope="col">Versão</th>
                <th scope="col">Data</th>
                <th scope="col">Publicado por</th>
                <th scope="col">Alterações</th>
              </tr>
            </thead>
            <tbody>
              @for (versao of historicoPaginado(); track versao.versao) {
                <tr data-testid="termo-detalhe-historico-linha">
                  <td class="termo-detalhe__historico-nowrap">{{ versao.versao }}</td>
                  <td class="termo-detalhe__historico-nowrap">{{ formatDate(versao.data) }}</td>
                  <td class="termo-detalhe__historico-nowrap">{{ versao.publicadoPor }}</td>
                  <td>{{ versao.alteracoes }}</td>
                </tr>
              }
            </tbody>
          </app-data-table>

          <app-pagination
            [currentPage]="historicoPage()"
            [pageSize]="historicoPageSize"
            [totalItems]="termo().historico.length"
            (pageChange)="onHistoricoPageChange($event)"
          />
        }

        @if (alterando()) {
          <p class="termo-detalhe__aviso" role="note">
            Ao salvar uma nova versão, a versão anterior permanecerá disponível no histórico.
          </p>
        }
      </div>
    }
  </form>
</section>
